<template lang="pug">
    #program-vs-program-reports.box
      WtTile(ancestor :col="12")

          WtTile(parent :col="12").no-padding.reportTile
            WtTile(child :col="4").no-padding
              WtTitle(h5) Program Vs Program Report
              | 
              WtTile This downloads a comparative report between programs for the program vs program challenges.
            WtTile(child :col="6").no-padding
              WtTile(parent :col="12").no-padding

                WtTile(child :col="12").no-padding.pr-2
                    BAutocomplete.autocomplete(
                        id="challenge"
                        :data="filteredChallenges"
                        v-model="selectedChallenge"
                        :open-on-focus="true"
                        :clearable="true"
                        :custom-formatter="challenge => formatChallengeName(challenge)"
                        placeholder="Select challenge..."
                        dropdown-position="bottom"
                        :icon="selectedChallengeIsFeatured ? 'star' : ''"
                        @select="value => handleChallengeSelect(value)"
                        max-height="120px"
                      )
                        template(slot-scope="props")
                          .media
                            BIcon.dropdown-star-icon(icon="star" v-if="props.option.featured")
                            .media-content
                              .content
                                div.ellipsis {{formatChallengeName(props.option)}}
                    WtTile(child :col="1" v-if="challengeId" child-class="no-padding")
                      RouterLink.button.is-text.is-small(
                        :to="{ path: '/challenges/'+challengeId}"
                      ) View Challenge
                WtTile(child :col="4" v-if="selectedChallenge").no-padding
                    WtButton(
                        color="primary"
                        class="download-btn"
                        :loading="processingDownload"
                        @click.native="downloadProgramVsProgramReport"
                        :disabled="downloadIsBeingEmailed.includes(this.challengeId)"
                    ) {{ downloadIsBeingEmailed.includes(this.challengeId) ? 'Report Sent' : 'DOWNLOAD' }}
    
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile.vue";
import WtButton from "@@/WtButton/WtButton.vue";
import { mapActions, mapGetters } from "vuex";
// Import necessary functionalities, mixins, and components similar to EveryStepReport.vue

export default {
  name: "ProgramVsProgramReport",
  components: { WtTitle, WtTile, WtButton },
  mixins: [
    /* Include necessary mixins */
  ],
  data() {
    return {
      selectedChallenge: null,
      processingDownload: false,
      selectedChallengeIsFeatured: false,
      challengeId: null,
      challenge: null,
      downloadIsBeingEmailed: []
    };
  },
  computed: {
    ...mapGetters("program", ["allChallenges"]),

    filteredChallenges() {
      if (this.selectedChallenge) {
        return this.allChallenges.filter(option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.selectedChallenge.toLowerCase()) >= 0 &&
            option.isPvsPChallenge
          );
        });
      } else {
        return this.allChallenges.filter(
          challenge => challenge.isPvsPChallenge
        );
      }
    }
  },

  mounted() {
    const programId = this.$auth.user().programId;
    this.fetchAllChallenges({ programId });
  },

  methods: {
    ...mapActions("program", [
      "fetchAllChallenges",
      "pVsPChallengeStatsDownload"
    ]),
    ...mapActions(["snackBar"]),

    handleChallengeSelect(item) {
      if (item) {
        this.challenge = item;
        this.challengeId = item.id;
        this.selectedChallengeIsFeatured = item.featured;
      }
    },

    formatChallengeName(challenge) {
      const statusArray = ["Pending", "Active", "Completed"];
      let formattedName = `${challenge.name} | `;
      if (challenge.featured) {
        formattedName = `Featured: ${formattedName}`;
      }
      let startDate = this.moment(challenge.startDate).format("MMM DD, YYYY");
      let endDate = this.moment(challenge.endDate).format("MMM DD, YYYY");
      formattedName += `${startDate} - ${endDate} | ${
        statusArray[challenge.status]
      }`;
      return formattedName;
    },

    async downloadProgramVsProgramReport() {
      this.processingDownload = true;

      try {
        let response = await this.pVsPChallengeStatsDownload(this.challengeId);

        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message:
            "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
        });
      }
      this.processingDownload = false;
    }
  }
};
</script>

<style lang="sass" scoped>
#program-vs-program-reports
  .dropdown-star-icon
    margin-left: -5px
  .media-content
    max-width: 100%
  .ellipsis
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  .ellipsis:hover
    text-overflow: clip
    white-space: normal
    word-break: break-all
  .dropdown-container
    position: relative
    z-index: 1000
    overflow: visible
</style>
